var mianliao = {
    "app_id": 207917,
    "AppId": "",
    "map": [
        // 中文版 https://izt.eastfair.cn/h5-web/#/mlact
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanguan.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/zong.png&title=一览图", // 多个用|分隔 参考注释
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanwei.png",
            "url": "/conference?theme=mianliao&key=mapDetail&title=展位图",
            // "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/expect.jpg&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/jiaotong.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/jiaotong1.png|https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/jiaotong2.png&title=交通图",
            "urlType": "TOPATH"
        }
    ],
    // 中文版 https://izt.eastfair.cn/h5-web/#/mlact
    "mapDetail": [
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/1.2.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/1.2.png&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/5.1.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/5.1.png&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/6.1.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/6.1.png&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/6.2.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/6.2.png&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/7.1.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/7.1.png&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/7.2.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/7.2.png&title=展位图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/8.1.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/8.1.png&title=展位图",
            "urlType": "TOPATH"
        },
    ],
    // 沙线访问路径 https://izt.eastfair.cn/h5-web/#/conference?theme=mianliao&key=sxmap
    "sxmap": [
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanguan.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/layout.png&title=展馆分布图",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanwei.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/sxzw.jpg&title=展位图",
            // "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/expect.jpg",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/jiaotong.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/traffic.png&title=交通图",
            // "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/expect.jpg",
            "urlType": "TOPATH"
        }
    ],
    // 英文版 https://izt.eastfair.cn/h5-web/#/conference?theme=mianliao&key=hwmap
    "hwmap": [
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanguan_en.png",
            // "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2023/view.png|https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2023/traffic.png&title=Hall Overview",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/zong.png&title=Hall Overview",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/zhanwei_en.png",
            "url": "/conference?theme=mianliao&key=hwMapDetail&title=Hall Plan",
            // "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/expect.jpg&title=Hall Plan",
            "urlType": "TOPATH"
        }
    ],
    // 英文版地址 https://izt.eastfair.cn/h5-web/#/conference?theme=mianliao&key=hwMapDetail
    "hwMapDetail": [
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/1.2_en.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/1.2.png&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/5.1_en.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/5.1.png&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/6.1_en.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/6.1.png&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/6.2_en.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/6.2.png&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/7.1_en.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/7.1.png&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/7.2_en.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/7.2.png&title=Hall Plan",
            "urlType": "TOPATH"
        },
        {
            "title": "",
            "bgimg": "https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/h5/mianliao/2025/chun/8.1_en.png",
            "url": "/jrdetail?type=3&src=https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/image-file/mianliao/8.1.png&title=Hall Plan",
            "urlType": "TOPATH"
        }
    ]
}

export default mianliao;